import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const MUTATION_CREATE_CATEGORY_FAQ = print(gql`
  mutation CategoryFaqs($data: CreateCategoryFaqInput!) {
    createCategoryFaq(data: $data) {
      id
      name
      slug
      sort
    }
  }
`);

export interface CategoryFaqMutationCreateGql {
  createCategoryFaq: {
    id: number;
    name: string;
    slug: string;
    sort: number;
  };
}
